import React from 'react';
import ComponentHelper from '../../../supers/ComponentHelper';
import { NavLink, Route } from 'react-router-dom';
import RoutingService from '../../../services/RoutingService';
import RESTService from '../../../services/RESTService';
import AgentsSetup from '../../agents-setup/AgentsSetup';
import IDPConfig from '../../idp-config/IDPConfig';
import EnvironmentsPanel from '../../environments-panel/EnvironmentsPanel';

const connect = new RESTService();
const RS = new RoutingService();

class TenantManagement extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			tenant: {},
			environments: [],
			envOptions: [
				{
					value: RS.getCurrentEnvironment(),
					label: RS.getCurrentEnvironment()
				}
			],
			envApplications: [],
			envDescription: '',
			currentSandbox: RS.getCurrentEnvironment()
		};
		this.autoBind(['onEnvChange']);
	}

	componentDidMount() {
		connect
			.getTenantByName(RS.getCurrentTenant())
			.then(res => {
				this.setData('tenant', res.data);
			})
			.catch(res => {
				//TODO's use the new error object
				console.log(res.response.data);
			});
	}

	onEnvChange(evt) {
		this.observe(() => {
			this.data.currentEnv = evt.value;
			RS.setCurrentEnvironment(evt.value);
		});
	}

	render() {
		const { match } = this.props;
		return (
			<div className="tenant-management-view">
				<div className="header hbox grow-1">
					<div className="title hbox vcenter grow-1 ellipse">
						<div className="text">Tenant</div>
						<i className="mdi mdi-chevron-right" />
						<div className="tenant">{RS.getCurrentTenant()}</div>
					</div>
				</div>
				<div className="tab-ctn hbox grow-1 animated fadeIn">
					<NavLink to={`/tenant-management/${match.params.tenant}/environments`} className="tab vbox vcenter hcenter">
						Environments
					</NavLink>
					<NavLink to={`/tenant-management/${match.params.tenant}/agents`} className="tab vbox vcenter hcenter">
						Agent Setup
					</NavLink>
					<NavLink to={`/tenant-management/${match.params.tenant}/idp`} className="tab vbox vcenter hcenter">
						IDP Setup
					</NavLink>
					{/*<NavLink to={`/tenant-management/${match.params.tenant}/config`} className="tab vbox vcenter hcenter">*/}
					{/*Tenant Configuration*/}
					{/*</NavLink>*/}
				</div>
				<div className="tab-content">
					<Route exact path={`/tenant-management/${match.params.tenant}/environments`} component={EnvironmentsPanel} />
					<Route exact path={`/tenant-management/${match.params.tenant}/agents`} component={AgentsSetup} />
					<Route exact path={`/tenant-management/${match.params.tenant}/idp`} component={IDPConfig} />
					<Route exact path={`/tenant-management/${match.params.tenant}/config`} />
				</div>
			</div>
		);
	}
}
export default TenantManagement;



// WEBPACK FOOTER //
// ./src/views/tenants-panel/tenant-management/TenantManagement.js